
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 22c1.4 0 2.538-1.12 2.538-2.5H9.46c0 1.38 1.137 2.5 2.538 2.5zm8.547-5.848c-.767-.811-2.202-2.03-2.202-6.027 0-3.035-2.162-5.465-5.077-6.06V3.25C13.268 2.56 12.7 2 12 2c-.7 0-1.269.56-1.269 1.25v.814c-2.915.596-5.077 3.026-5.077 6.061 0 3.996-1.434 5.216-2.2 6.027a1.21 1.21 0 00-.343.848 1.26 1.26 0 001.274 1.25h15.23c.76 0 1.27-.61 1.274-1.25a1.21 1.21 0 00-.341-.848z","fill":"#fff"}})])
          )
        }
      }
    